Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../../styles");
var _reactNativeSafeAreaContext = require("react-native-safe-area-context");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    sizing = _STYLES$useStyles.sizing;
  var insets = (0, _reactNativeSafeAreaContext.useSafeAreaInsets)();
  var container = Object.assign({}, _reactNative.StyleSheet.absoluteFillObject);
  var topBar = {
    position: 'absolute',
    zIndex: 1,
    top: insets.top
  };
  var scrollContentContainer = {
    flexGrow: 1,
    paddingTop: sizing.topBarHeightDefault + insets.top,
    paddingBottom: (0, _styles.getREM)(3)
  };
  var content = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    paddingBottom: spacing.page.padding.paddingBottom,
    paddingRight: spacing.page.padding.paddingRight,
    paddingLeft: spacing.page.padding.paddingLeft
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    topBar: topBar,
    scrollContentContainer: scrollContentContainer,
    content: content
  });
  return {
    styles: styles
  };
};